import { useFlags } from "launchdarkly-react-client-sdk";

import { useUser } from "src/contexts/user-context";
import { isHightouchStaffUser } from "src/utils/user";

/**
 * Whether the signed-in user is Hightouch staff, honoring the
 * `pretendImNotAHightouchAdmin` flag so "see it as a customer does" keeps
 * working.
 *
 * Prefer this over calling `isHightouchStaffUser` directly: every surface that
 * hides staff-only affordances needs the same user, the same flag, and the same
 * predicate, and a site that forgets the flag stays visible when a staffer is
 * deliberately pretending to be a customer.
 */
export function useIsHightouchStaff(): boolean {
  const { user } = useUser();
  const { pretendImNotAHightouchAdmin } = useFlags();
  return isHightouchStaffUser(user?.admin_type, {
    pretendImNotAHightouchAdmin,
  });
}
